var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStickerrMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833374 10.0002C0.833374 4.93755 4.93743 0.833496 10 0.833496C10.2211 0.833496 10.433 0.921293 10.5893 1.07757L18.9226 9.41091C19.0789 9.56719 19.1667 9.77915 19.1667 10.0002C19.1667 15.0628 15.0627 19.1668 10 19.1668C4.93743 19.1668 0.833374 15.0628 0.833374 10.0002ZM8.90562 2.57944C5.28224 3.10919 2.50004 6.22977 2.50004 10.0002C2.50004 14.1423 5.8579 17.5002 10 17.5002C13.7974 17.5002 16.9356 14.678 17.4317 11.0166C16.9772 11.0745 16.4082 11.1163 15.777 11.0934C14.2215 11.0368 12.1996 10.5808 10.6394 8.90054C9.09707 7.23959 8.74727 5.33887 8.77625 3.88975C8.7861 3.39716 8.83946 2.95237 8.90562 2.57944ZM10.4813 3.32663L16.576 9.42133C16.3455 9.43346 16.0974 9.43724 15.8376 9.4278C14.5286 9.3802 13.0088 9.00285 11.8607 7.76645C10.6947 6.51073 10.4195 5.07812 10.4426 3.92308C10.4468 3.71273 10.461 3.51284 10.4813 3.32663Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickerrMessage);
export default __webpack_public_path__ + "static/media/StickerrMessage.f1794b33b50ff5bf3c2231f4de1db11c.svg";
export { ForwardRef as ReactComponent };